import React, {Component} from 'react';
import {connect} from 'react-redux';
import Modal from '../UI/Modal';
import {Icon} from '../UI/Icon';
import {classNamesPrefixed} from '../../../helpers/CoreHelpers';
import Collapsible from 'react-collapsible';
import { collapsibleSettings } from '../../helpers/Helpers';
import BtnPrimary from "../UI/BtnPrimary";
import BtnSecondary from "../UI/BtnSecondary";

class ListField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            items: [],
            itemTitle: '',
            edit: false,
            editIndex: null
        };
    }

    componentDidMount() {
        const {value} = this.props.input;

        if (value) {
            this.setState({
                items: value
            });
        }
    }

    save() {
        const {itemTitle, items, edit, editIndex} = this.state;

        if (itemTitle !== '') {
            let newItems = items ? items : [];

            if (edit && editIndex !== null) {
                newItems[editIndex] = itemTitle;
            } else {
                newItems.push(itemTitle);
            }

            this.setState({
                items: newItems,
                modal: false,
                edit: false,
                editIndex: null
            }, () => this.props.input.value !== '' ? this.props.change(null, items) : this.props.input.onChange(items));
        }
    }

    showModal() {
        this.setState({
            modal: true
        });
    }

    hideModal() {
        this.setState({
            modal: false
        });
    }

    edit(title, index) {
        this.setState({
            edit: true,
            editIndex: index,
            itemTitle: title
        }, () => this.showModal());
    }

    remove(index) {
        const {items} = this.state;

        let newItems = items;
        newItems.splice(index, 1);

        this.setState({
            items: newItems
        }, () => this.props.change(this.props.name, items));
    }

    render() {
        const {modal, items, itemTitle, edit} = this.state;
        const {label, meta: {touched, error}, expanded} = this.props;

        return (
            <Collapsible
                {...collapsibleSettings}
                trigger={<label className={classNamesPrefixed({"trigger__label":true})}>{label ? label : 'Template'}</label>}
                open={expanded}
            >
                <Modal
                    showModal={modal}
                    onClose={() => {
                        this.hideModal();
                    }}
                    title={edit ? "Edit" : "Add an Item"}
                    icon="bars"
                    modalFooter={
                        <div className={classNamesPrefixed({'form-actions': true})}>
                            <BtnPrimary
                                small
                                icon={"save"}
                                onClick={(e) => {
                                    e.preventDefault();

                                    this.save();
                                }}
                            >Save</BtnPrimary>
                        </div>
                    }
                >
                    <div>
                        <div
                            className={classNamesPrefixed({
                                'form-item': true,
                                'form-text': true
                            })}
                        >
                            <label htmlFor="item_title">Item title</label>
                            <input
                                type="text"
                                id="item_title"
                                name="item_title"
                                value={itemTitle}
                                onChange={(e) => {
                                    this.setState({
                                        itemTitle: e.target.value
                                    });
                                }}
                            />
                        </div>
                        <br/>
                    </div>
                </Modal>
                <p>
                    <i
                        className={classNamesPrefixed({
                            'grey-color': true
                        })}
                    >Add a item.</i>
                </p>

                    <div>
                        <ul
                            className={classNamesPrefixed({
                                'grey-color': true,
                                'default-list': true
                            })}
                        >
                            {items.map((item, index) => {
                                return (
                                    <li key={index}>
                                        <i>{item}</i>
                                        <a onClick={() => this.remove(index)}><Icon name='trash'/>Remove</a>
                                        <a onClick={() => this.edit(item, index)}><Icon name='pencil'/>Edit</a>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                    <div
                        className={classNamesPrefixed({
                            'form-actions': true
                        })}
                    >
                        <BtnSecondary
                            small
                            onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                    itemTitle: '',
                                    edit: false
                                }, () => this.showModal());
                            }}
                        >
                            Add item
                        </BtnSecondary>
                    </div>
                {touched && error && <div className={classNamesPrefixed({'input-below-error': true})}>{error}</div>}
            </Collapsible>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ListField)


// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/ListField.js